import { getFeaturedComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedComics() {
  const featuredComics = getFeaturedComics();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            <i className="ri-star-fill text-primary-500 mr-2"></i>
            推荐漫画
          </h2>
          <p className="text-sm text-foreground-500 mt-1">精选高分热门漫画，不容错过</p>
        </div>
      </div>
      <div data-product-shop className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
        {featuredComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}